/* ==========================================================================
   Toast — Vapt Menu Design System
   ========================================================================== */

.container {
  position: fixed;
  top: var(--space-4);
  right: var(--space-4);
  z-index: 200;
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  max-width: 400px;
  pointer-events: none;
}

.toast {
  display: flex;
  align-items: flex-start;
  gap: var(--space-3);
  padding: var(--space-3) var(--space-4);
  background-color: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-lg);
  pointer-events: auto;
  animation: slideIn var(--transition-base) ease;
}

.toast.exiting {
  animation: slideOut var(--transition-fast) ease forwards;
}

.icon {
  flex-shrink: 0;
  margin-top: 1px;
}

.success .icon { color: var(--color-success); }
.error .icon   { color: var(--color-error); }
.info .icon    { color: var(--color-secondary); }

.content {
  flex: 1;
  min-width: 0;
}

.message {
  font-size: var(--text-body-sm-size);
  font-weight: 500;
  color: var(--color-text-primary);
  line-height: 1.4;
}

.description {
  font-size: var(--text-label-size);
  color: var(--color-text-secondary);
  margin-top: 2px;
  line-height: 1.4;
}

.closeBtn {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  color: var(--color-text-secondary);
  border: none;
  background: none;
  cursor: pointer;
  border-radius: var(--radius-sm);
  transition: color var(--transition-fast);
}

.closeBtn:hover {
  color: var(--color-text-primary);
}

@keyframes slideIn {
  from { opacity: 0; transform: translateX(16px); }
  to   { opacity: 1; transform: translateX(0); }
}

@keyframes slideOut {
  from { opacity: 1; transform: translateX(0); }
  to   { opacity: 0; transform: translateX(16px); }
}

/*
   No celular o container ancorado no topo cobria a Topbar inteira — menu,
   avatar e "Sair" — e deixava o × do toast a 25px do × do banner de trial,
   dois alvos pequenos coladinhos com efeitos bem diferentes. Ancorando
   embaixo, o toast nao disputa espaco com nenhuma barra fixa.
   ========================================================================== */

@media (max-width: 767px) {
  .container {
    top: auto;
    right: var(--space-3);
    bottom: var(--space-4);
    left: var(--space-3);
    max-width: none;
    flex-direction: column-reverse;
  }

  .closeBtn {
    width: 44px;
    height: 44px;
  }
}
